var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mb-5"},[_c('span',{staticClass:"display-4 col-12"},[_vm._v(" "+_vm._s(`${_vm.reseller.name}`)+" - "+_vm._s(_vm.$t("COMMON.LOGS"))+" ")])]),_c('log-list-table',{attrs:{"filterSubject":_vm.reseller}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }